import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const FormContainer = styled.div`
  width: 70%;
`;
